import _ from 'lodash'

export const hasCompletedRegistrationConfig = (event, registrationOptions, secondary = false) => {
  // Primary sync checks
  if (!secondary) {
    if (!event || !event.registrationType) return false
    if (!event.externalEventId) return false

    const registrationType = _.find(registrationOptions, (o) => o.label === event.registrationType)
    if (registrationType === undefined) return false
    if (registrationType.type === 'API Key' && !event.externalAccountId && !event.apiKey)
      return false
    if (
      registrationType.type === 'OAuth 2.0 Client Credentials' &&
      (!event.clientId || !event.clientSecret)
    )
      return false
    return true
  }

  // Secondary sync checks - Only RCS is supported
  // API Key secondary sync doesn't require externalAccountId
  if (!event || !event.secondaryRegistrationType) return false
  if (!event.secondaryEventName) return false

  if (event.secondaryRegistrationType !== 'RCS') return false
  if (!event.secondaryEventName && !event.secondaryApiKey) return false
  return true
}
